export default class ItemStatus {
  constructor() {
    const statusEl = document.querySelectorAll('.js-service-status');

    if (statusEl.length) {
      statusEl.forEach((el) => {
        this.checkStatus(el);
      });
    }
  }

  checkStatus(el) {
    const me = this;
    const { config } = window.solodev;
    const subscriptionName = el.getAttribute('data-name');
    const entityName = el.getAttribute('data-entity');
    const objectId = el.getAttribute('data-id');
    let url = '';
    if (objectId && entityName) {
      url = `${window.origin}/o/${config.orgName}/status/${entityName}/${objectId}`;
    } else {
      url = `${window.origin}/o/${config.orgName}/service/${subscriptionName}/status`;
    }

    $.ajax({
      url: url,
      success(data) {
        const currentLabel = el.querySelector('strong');
        if (currentLabel && currentLabel.innerText.toLowerCase() !== data.label.toLowerCase()) {
          location.reload();
        }
        me.render(el, data);
        setTimeout(() => me.checkStatus(el), 30000);
      }
    });
  }

  render(el, data) {
    const self = this;
    const { label, color, action = null } = data;

    if (action) {
      el.addEventListener('click', self.onClick.bind(this, action))
    }

    if (color && label) {
      el.setAttribute('class', `sd-service-status is__${color} ${action ? 'pointer' : ''}`);
      el.innerHTML = `
        <i class="fas fa-circle fa-sm pe-1"></i>
        <strong>${label}</strong>
      `;
    }
  }

  onClick(action) {
    if (action.is_modal_action) {
      top.loadAction(
        action.url,
        action.name,
        action.icon,
        action.display_type
      );
    } else {
      window.location = action.url;
    }
  }
}
